export const textStyles = {
  fontFamily: "Roboto Condensed",
  fontSize: "20px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  color: "var(--typography-graphics-black-000000, #000)",
};
export const formsItemWrapper = {
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",
};
export const deleteIconButton = {
  color: "white",
  backgroundColor: "red",
  width: "22px",
  height: "22px",
  padding: "0px",
};
